import React from 'react';
import { ActionRow } from './ActionRow';

export interface ModalFooterProps {
  children: React.ReactNode;
  className?: string;
  actionRowClassName?: string;
}

export const ModalFooter: React.FC<ModalFooterProps> = ({
  children,
  className = '',
  actionRowClassName = '',
}) => {
  return (
    <div className={`border-t border-[#E2DDD8] bg-[#FFFFFF] px-6 py-4 ${className}`.trim()}>
      <ActionRow className={actionRowClassName}>{children}</ActionRow>
    </div>
  );
};
